// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0acf2f02","310":"adedc9db","453":"52140860","455":"fc1ac4dc","631":"ed74ed3f","666":"fc970825","764":"8fef9d0b","900":"71444237"}[chunkId] + ".chunk.js";
};